import {
  Layout,
  Row,
  Col,
  Menu,
  Button,
  Dropdown,
  Typography,
  Drawer,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
  GlobalOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { useEffect, useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { UserContext } from "../../../context/User.context";
import { LanguageContext } from "../../../context/Language.contex";
import { useMediaQuery } from "react-responsive";
import Logo from "../../../component/Logo/Logo";

const { Header } = Layout;
const { Text } = Typography;

const CustomHeader2 = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const { toggleLanguage, currentLanguage, language } =
    useContext(LanguageContext);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let scrollTimeout;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
      }
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsVisible(true);
      }, 300);
      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const logout = () => {
    setLoading(true);
    setTimeout(() => {
      if (!loading) {
        setUser(null);
        localStorage.clear();
        navigate("/login");
      }
    }, 1000);
  };

  const userDropdownItems = [
    {
      key: "1",
      label: (
        <div style={{ textAlign: "center" }}>
          <a onClick={() => navigate("/user")}>
            <DashboardOutlined style={{ marginRight: 5 }} />
            Dashboard
          </a>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          onClick={logout}
          icon={<LogoutOutlined />}
          loading={loading}
          danger
          type="primary"
          style={{ width: "100%" }}
        >
          Logout
        </Button>
      ),
    },
  ];

  const languageOptions = [
    {
      key: "id",
      label: "Bahasa Indonesia",
      onClick: () => toggleLanguage("id"),
    },
    {
      key: "en",
      label: "English",
      onClick: () => toggleLanguage("en"),
    },
    {
      key: "chi",
      label: "中文 (Chinese)",
      onClick: () => toggleLanguage("chi"), // Set to Chinese
    },
  ];

  const navigationItems = [
    { title: "Home", route: "/" },
    { title: language[15], route: "/event" },
    { title: language[16], route: "/career" },
    { title: language[19], route: "/about" },
  ];

  const MobileMenu = () => (
    <Drawer
      title="Menu"
      placement="right"
      onClose={() => setDrawerVisible(false)}
      open={drawerVisible}
    >
      <Menu mode="vertical" selectable={false}>
        {navigationItems.map((item) => (
          <Menu.Item
            key={item.title}
            onClick={() => {
              navigate(item.route);
              setDrawerVisible(false);
            }}
          >
            {item.title}
          </Menu.Item>
        ))}
        <Menu.Divider />
        {user ? (
          <>
            <Menu.Item key="user" icon={<UserOutlined />}>
              <a onClick={() => navigate("/user")}>Dashboard</a>
            </Menu.Item>
            <Menu.Item key="logout">
              <Button
                onClick={() => {
                  logout();
                  setDrawerVisible(false);
                }}
                icon={<LogoutOutlined />}
                loading={loading}
                danger
                type="primary"
                style={{ width: "100%" }}
              >
                Logout
              </Button>
            </Menu.Item>
          </>
        ) : (
          <Menu.Item key="login">
            {/* <Button
              type="primary"
              onClick={() => {
                // navigate("/login");
                setDrawerVisible(false);
              }}
              style={{ width: "100%" }}
            >
              {language[22]}
            </Button> */}
          </Menu.Item>
        )}
        <Menu.SubMenu
          key="lang"
          title={`Language: ${
            currentLanguage === "id"
              ? "ID"
              : currentLanguage === "en"
              ? "EN"
              : "ZW"
          }`}
          icon={<GlobalOutlined />}
        >
          {languageOptions.map((opt) => (
            <Menu.Item key={opt.key} onClick={opt.onClick}>
              {opt.label}
            </Menu.Item>
          ))}
        </Menu.SubMenu>
      </Menu>
    </Drawer>
  );

  return (
    <>
      <Header
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          padding: "0 20px",
          position: "sticky",
          top: 0,
          zIndex: 999,
          transition: "transform 0.3s ease-in-out",
          transform: isVisible ? "translateY(0)" : "translateY(-100%)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Row justify="space-between" align="middle" style={{ height: "64px" }}>
          <Col>
            <Link to="/" style={{ fontWeight: "bold", fontSize: 50 }}>
              {/* <Text>LOGO</Text> */}
              <Logo />
            </Link>
          </Col>

          <Col>
            {isMobile ? (
              <Button
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
              />
            ) : (
              <Row align="middle" gutter={16}>
                {navigationItems.map((item) => (
                  <Col key={item.title}>
                    <Button
                      type="text"
                      style={{ fontWeight: 500 }}
                      onClick={() => navigate(item.route)}
                    >
                      {item.title}
                    </Button>
                  </Col>
                ))}
                <Col>
                  {user ? (
                    <Dropdown
                      menu={{ items: userDropdownItems }}
                      placement="bottomRight"
                    >
                      <Button icon={<UserOutlined />} />
                    </Dropdown>
                  ) : (
                    // <Button
                    //   type="primary"
                    //   onClick={() => {
                    //     // navigate("/login");
                    //   }}
                    // >
                    //   {language[22]}
                    // </Button>
                    <></>
                  )}
                </Col>
                <Col>
                  <Dropdown
                    menu={{ items: languageOptions }}
                    placement="bottomRight"
                  >
                    <Button icon={<GlobalOutlined />}>
                      {currentLanguage === "id"
                        ? "ID"
                        : currentLanguage === "en"
                        ? "EN"
                        : "ZW"}
                    </Button>
                  </Dropdown>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Header>

      {isMobile && <MobileMenu />}
    </>
  );
};

export default CustomHeader2;
